<script lang="ts" setup>
import AppStepperButton from '../appStepperButton/AppStepperButton.vue';

interface AppNumberInputProps {
  value: number;
  onlyStepwiseInput?: boolean;
  disableDecrease?: boolean;
  disableIncrease?: boolean;
}

const props = defineProps<AppNumberInputProps>();

interface AppNumberInputEmits {
  (eventName: 'change', withValue: number): void;
  (eventName: 'increase'): void;
  (eventName: 'decrease'): void;
}

const emit = defineEmits<AppNumberInputEmits>();

function updateValue(withValue: number): void {
  if (props.onlyStepwiseInput) {
    if (withValue < 0) {
      emit('decrease');
    } else {
      emit('increase');
    }
  } else {
    emit('change', props.value + withValue);
  }
}

function setValue(newValue: number): void {
  emit('change', newValue);
}
</script>

<template>
  <div t-id="NumberInput" class="app-number-input">
    <AppStepperButton
      t-id="DecreaseButton"
      :state="props.disableDecrease ? 'disabled' : 'enabled'"
      size="medium"
      :icon="{ name: 'minus' }"
      @click="updateValue(-1)"
    />

    <input
      t-id="InputTypeNumber"
      type="number"
      class="input"
      :value="value"
      :readonly="onlyStepwiseInput"
      @change="setValue(Number(($event.target as HTMLInputElement).value))"
      @input="setValue(Number(($event.target as HTMLInputElement).value))"
    />

    <AppStepperButton
      t-id="IncreaseButton"
      :state="props.disableIncrease ? 'disabled' : 'enabled'"
      size="medium"
      :icon="{ name: 'plus' }"
      @click="updateValue(1)"
    />
  </div>
</template>

<style scoped lang="scss">
@import '../../styles/_fonts.scss';
.app-number-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  touch-action: manipulation;

  .input {
    border: none;
    margin: 0 var(--spacing-4);
    width: 40px;
    height: 40px;
    border-radius: var(--border-radius-12);
    text-align: center;
    padding: 0;
    -moz-appearance: textfield;
    appearance: textfield;
    @include font-label-l-bold;
    background-color: transparent;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
